import { apiFormDataPost } from '../../../utils';
import { UploadConsulteesResponse } from '../../types';

export const uploadConsultees = (request: FormData): Promise<UploadConsulteesResponse> =>
  apiFormDataPost<UploadConsulteesResponse, FormData>(`admin/consulteeupload`, request);
